<template>
  <v-form ref="form" @submit.prevent="validate">
    <v-text-field
      :label="$t('auth.username')"
      prepend-icon="mdi-account"
      v-model="username"
      required
      :error-messages="errorMessages.email"
    ></v-text-field>

    <v-text-field
      :label="$t('auth.password')"
      prepend-icon="mdi-lock"
      type="password"
      v-model="password"
      required
    ></v-text-field>

    <div class="text-center">
      <v-btn
        :loading="loading"
        color="primary"
        large
        type="submit"
        text
        rounded
        >{{ $t("auth.sign_in") }}</v-btn
      >
    </div>

  </v-form>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      username: null,
      password: null,
      errorMessages: {},
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      login: "auth/login",
    }),
    async validate() {
      if (this.$refs.form.validate()) {
                this.loading = true;
                let url = this.$store.getters.base_api + 'auth/login';
                let params = {
                      username   : this.username,
                      password   : this.password,
                }
                this.req.post(url,params).then( response => {
                  if(response.data.code=='200'){
                    this.colorsnackbar = 'green darken-1';
                    this.textsnackbar = 'เข้าสู่ระบบสำเร็จ กรุณารอสักครู่...';
                    this.snackbar = true;
                     let tokenAccess = response.data.token;
                     localStorage.setItem('tokenAccess',tokenAccess);
                     this.$store.commit('set_auth',response.data.data);
                     window.location.href = this.$store.getters.base_url + 'admin/landing/'+response.data.data.locale;

                  }else if(response.data.code=='201'){
                    this.colorsnackbar = 'red darken-1';
                    this.textsnackbar = response.data.message;
                    this.snackbar = true;
                    this.loading = false;
                  }

                }).catch( error => {
                    this.colorsnackbar = 'red darken-1';
                    this.textsnackbar = 'ไม่สามารถเข้าระบบได้ ไม่พบข้อมูลผู้ใช้';
                    this.snackbar = true;
                    this.loading = false;
                });
            }
    },
  },
  mounted() {
    
    this.req = this.$store.getters.req;

  },
};
</script>
<style type="text/css">
  .v-application .login-card {
          background-color: #2b3b90 !important;
          border-color: #2b3b90 !important;
      }
</style>
<style scoped>
#login-page {
  background-color: var(--v-primary-lighten5);
}
</style>
